import CertignaCard from './CertignaCard';

export default CertignaCard;
